import Card from '../../components/Card';
import {
  Table,
  Thead,
  Tbody,
  Td,
  Th,
  Spinner,
  Text,
  VStack,
  Tr,
  Icon,
  HStack,
  Tooltip,
  Center,
} from '@chakra-ui/react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { shortAddress } from '../../utils/contracts';
import BigNumber from 'bignumber.js';
import { useAccount } from 'wagmi';
import { FiInfo } from 'react-icons/fi';
import SectionTitle from '../../components/SectionTitle';

type LeaderboardUser = {
  userAddress: string;
  userAmount: string;
  stakingStart: number;
  points: number;
};

export default function Leaderboard() {
  const { address } = useAccount();

  const { data: leaderboard, isLoading } = useQuery({
    queryKey: ['leaderboard'],
    queryFn: () => axios.get('/xed-staking/leaderboard'),
    refetchInterval: 30000,
  });

  return (
    <VStack w="100%" py="10">
      <SectionTitle title="Staking Leaderboard" />
      <Card w="100%" maxW="1200px">
        <VStack w="100%" align="start" spacing="2">
          <Table w="100%" variant="unstyled" fontSize="sm" size={{ base: 'xs', md: 'md' }}>
            <Thead>
              <Tr>
                <Th maxW="90px">
                  <Text>Rank</Text>
                </Th>
                <Th>
                  <Text>Address</Text>
                </Th>
                <Th>
                  <Text>Points</Text>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {isLoading ? (
                <Tr>
                  <Td>
                    <Spinner size="sm" />
                  </Td>
                </Tr>
              ) : (
                (leaderboard?.data as LeaderboardUser[])?.map(
                  (user: LeaderboardUser, index: number) => (
                    <Tr
                      key={user.userAddress}
                      color={address === user.userAddress ? 'brand.400' : 'white'}
                      borderColor="brand.500"
                      fontSize={{ base: 'xs', md: 'sm' }}
                    >
                      <Td>{index + 1}</Td>
                      <Td>
                        <Text>{shortAddress(user.userAddress)}</Text>
                      </Td>
                      <Td>
                        <HStack w="100%" justify="space-between">
                          <Text>{BigNumber(user.points).toFixed(0)}</Text>
                          <Tooltip
                            label={`${BigNumber(user.userAmount)
                              .div(10 ** 18)
                              .toFixed()} $XED staked on ${format(
                              new Date(user.stakingStart * 1000),
                              'dd/MM/yyyy',
                            )}`}
                          >
                            <Center>
                              <Icon as={FiInfo} />
                            </Center>
                          </Tooltip>
                        </HStack>
                      </Td>
                    </Tr>
                  ),
                )
              )}
            </Tbody>
          </Table>
        </VStack>
      </Card>
    </VStack>
  );
}
